module.exports = __webpack_public_path__ + "static/media/CleanBg.c678e5b6.png";